module.exports = __webpack_public_path__ + "img/clo.4f8c51cd.svg";